/**
 * Category Domain Entity
 *
 * Represents a product category in the system.
 * Pure business logic, independent of framework or persistence.
 */

export interface CategoryProps {
  id: string;
  name: string;
  parentId: string | null;
  level: number;
}

export class Category {
  readonly id: string;
  readonly name: string;
  readonly parentId: string | null;
  readonly level: number;

  constructor(props: CategoryProps) {
    if (!props.id?.trim()) {
      throw new Error("Category ID is required");
    }
    if (!props.name?.trim()) {
      throw new Error("Category name is required");
    }
    if (props.level < 0) {
      throw new Error("Category level cannot be negative");
    }

    this.id = props.id;
    this.name = props.name;
    this.parentId = props.parentId;
    this.level = props.level;
  }

  /**
   * Check if this is a root category
   */
  isRoot(): boolean {
    return this.parentId === null && this.level === 0;
  }

  /**
   * Convert to serializable object
   */
  toJSON(): CategoryProps {
    return {
      id: this.id,
      name: this.name,
      parentId: this.parentId,
      level: this.level,
    };
  }

  /**
   * Create from serialized object
   */
  static fromJSON(json: CategoryProps): Category {
    return new Category(json);
  }
}
